import { addDays } from 'date-fns'
import { IRoom } from '../../models/Room'

export const createCacheCanvas = (callback, width?, height?) => {
  const auxCanvas = document.createElement('canvas')
  if (width) {
    auxCanvas.width = width
  }
  if (height) {
    auxCanvas.height = height
  }
  const ctx = auxCanvas.getContext('2d')
  callback(ctx)

  return auxCanvas
}

export function determineGridPosition<T extends IRoom>(
  constants,
  startDay: Date,
  startRoomIdx: number,
  scrollTop: number,
  scrollLeft: number,
  rooms: T[],
  x: number,
  y: number,
  forEvents?: boolean,
) {
  const position = {
    day: null as Date,
    room: null as T,
    x: null as number,
    y: null as number,
  }
  const xOffset = Math.round(scrollLeft % constants.GRID_WIDTH)
  const yOffset = Math.round(scrollTop % constants.GRID_HEIGHT)

  const roomPos = Math.floor((y + yOffset) / constants.GRID_HEIGHT)
  position.room = rooms[roomPos + startRoomIdx]
  position.y = roomPos

  const dayPos = Math.floor(
    (x + xOffset - (forEvents ? constants.GRID_WIDTH / 2 : 0)) /
    constants.GRID_WIDTH,
  )
  position.day = addDays(startDay, dayPos)
  position.x = dayPos

  return position
}

export function getDimensions<T extends IDimensions>(
  dim: T,
  size: number,
  isMobile,
  pixelRatio = 1,
): T {
  const dimensions = Object.entries(dim).reduce(
    (acc, [key, d]) => {
      acc[key] = Math.round(d * size * pixelRatio)
      return acc
    },
    {} as T,
  )

  if (isMobile) {
    dimensions.ROOM_WIDTH = dimensions.ROOM_WIDTH_MOBILE
  }
  dimensions.PIXEL_RATIO = pixelRatio

  return dimensions
}

export interface IDimensions {
  GRID_BORDER_WIDTH: number
  GRID_DIAGONAL_LINE_SPACING: number
  GRID_DIAGONAL_LINE_THICKNESS: number
  GRID_DIAGONAL_LINE_WIDTH: number
  GRID_HEIGHT: number
  GRID_WIDTH: number
  ROOM_FONT_SIZE: number
  ROOM_INTEGRATION_ICON_OVERLAP: number
  ROOM_INTEGRATION_ICON_SIZE: number
  ROOM_LINE_HEIGHT: number
  ROOM_PADDING_BOTTOM: number
  ROOM_PADDING_LEFT: number
  ROOM_PADDING_RIGHT: number
  ROOM_PADDING_TOP: number
  ROOM_SINGLE_LINE_PADDING_TOP: number
  ROOM_SIZE_FONT_SIZE: number
  ROOM_SIZE_TEXT_OFFSET: number
  ROOM_TRIANGLE_SIZE: number
  ROOM_TYPE_ICON_SIZE: number
  ROOM_WIDTH: number
  ROOM_WIDTH_MOBILE: number
  ROOM_WRAP_FROM_RIGHT: number
  HEADER_HEIGHT: number
  HEADER_DAY_FONT_SIZE: number
  HEADER_LABEL_FONT_SIZE: number
  HEADER_MARKED_DAY_BORDER: number
  HEADER_SELECTED_DAY_HEIGHT: number
  HEADER_SELECTED_DAY_WIDTH: number
  HEADER_TEXTS_PADDING: number
  PIXEL_RATIO: number
}
